import type { Data, SubjectsType } from '@aytm/app/insights/dashboard/models/types.ClientDTO'
import { ItemListModel, BlockModel } from '@aytm/app/insights/dashboard/models/BlockModel'
import { InsightsDashboardPoolState } from '@aytm/app/insights/dashboard/duckness/ducks/types'
import { getCurrentBlock } from '@aytm/app/insights/dashboard/helpers/requests'

export type StateSelectorParams = {
  dragInfoDraggedUid: string | null
  data: Data
  subjects: SubjectsType
  hiddenItems: Array<string>
  block: BlockModel | null
  blockItems: ItemListModel | null
  sortOrder: string | null
  currentSplit: string | null
  letterStore: Record<string, string>
  showData: boolean
  showMetadata: boolean
  showChart: boolean
  showTimeline: boolean
  subjectType: string
  enableSort: boolean
  fixPinned: boolean
}

export const stateSelector = (state: InsightsDashboardPoolState): StateSelectorParams => {
  const dragInfoDraggedUid = state.dragInfoDraggedUid || null
  const data = state.currentData?.data || {}
  const subjects = state.currentData?.subjects || {}
  const hiddenItems = state.currentData?.hiddenItems || []
  const block = getCurrentBlock(state)
  const blockItems = block?.getBlockItems()
  const sortOrder = block?.getObject('sortOrder') || null
  const currentSplit = block?.getObject('currentSplit') || null
  const letterStore = block?.getObject('letterStore') || {}
  const showData = block?.getObject('showData') ?? true
  const showMetadata = block?.getObject('showMetadata') ?? true
  const showChart = block?.getObject('showChart') || false
  const showTimeline = block?.getObject('showTimeline') || false
  const subjectType = block?.getSubjectType() || 'concept'
  const [enableSort, fixPinned] = 'concept' === subjectType ? [true, true] : [false, false]
  return {
    dragInfoDraggedUid,
    data,
    subjects,
    hiddenItems,
    block,
    blockItems,
    sortOrder,
    currentSplit,
    letterStore,
    showData,
    showMetadata,
    showChart,
    showTimeline,
    subjectType,
    enableSort,
    fixPinned
  }
}

export const shouldUpdate = (prev: StateSelectorParams, next: StateSelectorParams) =>
  !prev && !next
    ? false
    : (!prev && Boolean(next)) ||
      (Boolean(prev) && !next) ||
      prev.dragInfoDraggedUid !== next.dragInfoDraggedUid ||
      prev.data !== next.data ||
      prev.subjects !== next.subjects ||
      prev.hiddenItems !== next.hiddenItems ||
      prev.blockItems !== next.blockItems ||
      prev.sortOrder !== next.sortOrder ||
      prev.currentSplit !== next.currentSplit ||
      prev.showData !== next.showData ||
      prev.showMetadata !== next.showMetadata ||
      prev.showChart !== next.showChart ||
      prev.showTimeline !== next.showTimeline ||
      prev.subjectType !== next.subjectType
